// FIXME Separate form UI by ExampleResume or ExampleCv
import { CvExample } from '@/../gen';

export function makeInputValue(cvExample: CvExample) {
  return `${cvExample.source_type}_${cvExample.id}`;
}

export function inputValueToPayload(value: string) {
  if (value.indexOf('example_resume') >= 0) {
    return {
      sourceId: Number(value.replace('example_resume_', '')),
      sourceType: 'example_resume',
    };
  } else {
    return {
      sourceId: Number(value.replace('example_cv_', '')),
      sourceType: 'example_cv',
    };
  }
}

export function makeExampleUrl(cvExample: CvExample) {
  return cvExample.source_type === 'example_resume'
    ? `/resume/examples/${cvExample.slug}`
    : `/cv/examples/${cvExample.slug}`;
}
